<template>
  <div>
    <button
      type="button"
      class="assistant-launcher"
      :class="{ open }"
      @click="open = true"
      aria-label="Open NoCodeAgent Assistant"
    >
      <Sparkles :size="18" />
      <span>Assistant</span>
    </button>

    <div v-if="open" class="assistant-backdrop" @click="open = false"></div>

    <GlobalAssistantPanel
      :open="open"
      :agent-id="agentId"
      @close="open = false"
      @agent-applied="$emit('agent-applied')"
    />
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref } from 'vue'
import { Sparkles } from 'lucide-vue-next'
import GlobalAssistantPanel from '@/components/GlobalAssistantPanel.vue'

defineEmits(['agent-applied'])

defineProps({
  agentId: {
    type: [Number, String],
    default: ''
  }
})

const open = ref(false)
</script>

<style scoped>
.assistant-launcher{position:fixed;right:22px;bottom:22px;z-index:1400;display:inline-flex;align-items:center;gap:9px;min-height:48px;border:none;border-radius:999px;background:#17211b;color:#fff;padding:0 18px;font-weight:900;box-shadow:0 18px 40px rgba(15,23,42,.28);cursor:pointer}.assistant-launcher.open{opacity:0;pointer-events:none}.assistant-backdrop{position:fixed;inset:0;background:rgba(15,23,42,.28);z-index:1450}@media(max-width:640px){.assistant-launcher{right:14px;bottom:14px}.assistant-launcher span{display:none}.assistant-launcher{width:50px;height:50px;justify-content:center;padding:0}}
</style>
